import backButtonIcon from '@/assets/app/images/icon/icon-back-button_2.png';

interface HeaderProps {
  title: string;
  onBack?: () => void;
}

const TitleHeader = ({ title, onBack }: HeaderProps) => {
  return (
    <header className="relative flex items-center justify-center h-14 w-full bg-white px-4">
      <button
        className="absolute left-4 btn-back-theme"
        style={{ backgroundColor: '#0094EF', borderBottom: '4px solid #0070D6' }}
        onClick={onBack}
      >
        뒤로가기
      </button>
      <h1 style={{ fontSize: 24, fontWeight: 800, color: '#4B4B4B' }}>{title}</h1>
    </header>
  );
};

export default TitleHeader;
